// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__188F5","selects":"Documents_selects__2Ysrb"};